import { Reducer } from "redux";
import { AuthActionTypes, AuthState } from "./types";
import Tools from "utils/tools";

export const initAuthState: AuthState = {
  userInfo: {
    userId: "",
    realName: "",
    picture: "",
    gender: "",
    email: "",
    emailActive: false,
    mobile: "",
    mobileActive: false,
    cid: "",
    companyName: "",
    companyLogo: "",
    superUserId: ""
  },
  loginData: {
    appId:"",
    certStatus:"",
    companyList:[],
    deviceNo:"",
    email:"",
    emailActive:"",
    gender:"",
    kicked:false,
    lastLogin:"",
    loginAccount:"",
    loginIp:"",
    mobile:"",
    mobileActive:false,
    nickName:"",
    picture:"",
    realName:"",
    seconds:0,
    sourceCid:"",
    sourceFlag:"",
    statusFlag:"",
    ticket:"",
    token:"",
    userId:"",
  },
  commonMap: {},
  registerData: {}
}

const authReducer: Reducer<AuthState> = (state = initAuthState, action) => {
  switch (action.type) {
    
    // 更新状态
    case AuthActionTypes.FETCH_UPDATE_AUTH_STATE: {
      return {
        ...state,
        ...action.payload
      }
    }

    // 存储用户信息
    case AuthActionTypes.FETCH_STORE_USERINFO: {
      const { cid, token } = action.payload;
      const date = new Date();
      const expiresDays = 7;
      date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000);
      Tools.setCookie("ms_member_token", token, date);
      Tools.setCookie("ms_cid", cid, date);
      window.location.reload();
      return {
        ...state
      }
    }

    default: {
      return { ...state };
    }
  }
} 

export { authReducer }